import { useState } from "react";
import { Plus, UtensilsCrossed } from "lucide-react";
import { fileUrl, formatIDR } from "@/lib/api";
import { stitchDishImage } from "@/lib/stitch-menu-assets";

export function MenuImage({ item, className = "", ...props }) {
  const [failedSrc, setFailedSrc] = useState("");
  const src = item.image_url ? (item.image_url.startsWith("http") ? item.image_url : fileUrl(item.image_url)) : stitchDishImage(item.name);
  return src && src !== failedSrc ? <img src={src} alt={item.name} className={className} loading="lazy" {...props} onError={() => setFailedSrc(src)} /> : (
    <div className={`menu-image-fallback ${className}`} role="img" aria-label={`Foto ${item.name} belum tersedia`}>
      <UtensilsCrossed className="h-7 w-7 text-brass" aria-hidden="true" />
    </div>
  );
}

export function MenuCard({ item, onSelect, onAdd }) {
  const soldOut = item.available === false;
  return (
    <article data-testid={`menu-item-${item.id}`} className={`menu-card ${soldOut ? "menu-card-unavailable" : ""}`}>
      <button type="button" className="menu-card-detail" onClick={onSelect} data-testid={`menu-detail-${item.id}-btn`} aria-label={`Lihat detail ${item.name}`}>
        <div className="flex min-w-0 flex-1 flex-col justify-between">
          <div>
            <h3 className="font-display text-[22px] font-medium leading-7">{item.name}</h3>
            {item.description && <p className="mt-1 line-clamp-2 text-[13px] leading-[19px] text-muted-foreground">{item.description}</p>}
          </div>
          <p className="mt-2 text-[15px] font-bold tabular-nums text-heritage">{formatIDR(item.price)}</p>
        </div>
        <div className={`h-24 w-24 shrink-0 self-center overflow-hidden rounded-xl bg-accent ${soldOut ? "grayscale" : ""}`}>
          <MenuImage item={item} className="h-full w-full object-cover" />
        </div>
      </button>
      {soldOut ? <span className="menu-card-soldout" data-testid={`soldout-${item.id}`}>Sold out</span> : (
        <button type="button" data-testid={`add-item-${item.id}-btn`} onClick={onAdd} className="menu-card-add" aria-label={`Tambah ${item.name}`}>
          <Plus className="h-4 w-4" aria-hidden="true" />
        </button>
      )}
    </article>
  );
}

export function FeaturedMenuCard({ item, onSelect, onAdd }) {
  return (
    <article className="featured-menu-card" data-testid={`featured-item-${item.id}`}>
      <button type="button" onClick={onSelect} className="w-full text-left" aria-label={`Lihat pilihan ${item.name}`} data-testid={`featured-detail-${item.id}-btn`}>
        <MenuImage item={item} className="mb-3 h-36 w-full rounded-xl object-cover" />
        <h3 className="font-display text-[22px] font-medium leading-7">{item.name}</h3>
        {item.description && <p className="mt-1 line-clamp-2 min-h-[38px] text-[13px] leading-[19px] text-muted-foreground">{item.description}</p>}
      </button>
      <div className="mt-3 flex items-center justify-between gap-3">
        <span className="text-[15px] font-bold tabular-nums text-heritage">{formatIDR(item.price)}</span>
        <button type="button" onClick={onAdd} className="featured-menu-add" aria-label={`Tambah pilihan ${item.name}`} data-testid={`featured-add-${item.id}-btn`}>
          <Plus className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    </article>
  );
}
